export default __webpack_public_path__ + "static/media/1604303957-9571.4f065694.jpg";